<template>
    <div class="BlankWrapper">

        <!--        <iframe  v-if="newsContent.newsKind==4" id="show-iframe"  frameborder=0 name="showHere" scrolling=auto :src="newsContent.path" :height="clientHeight" style="width: 100%;position: absolute;height: 100%;top: 0;left: 0" ></iframe>-->
        <div v-if="newsContent.newsKind=='v'">
            <div class="newsInfo">
                <div class="newsTitle">{{newsContent.newsTitle}}</div>
                <div class="source">来源：{{newsContent.source||"暂无"}}</div>

            </div>
            <div :class="['videoWrapper','singleRadius']" @click="()=>onVideo()" :style="`height:${videoHeight}px`">
                <div class="videoPlay" style="height: 100%;">
                    <video id="video" width="100%" :poster="newsContent.imgUrl"
                           style="width: 100%; height:100%;"
                           :src="newsContent.videoUrl" webkit-playsinline="true"
                           x-webkit-airplay="true" playsinline="true" x5-playsinline="true" x5-video-player-type="h5"
                           x5-video-player-fullscreen="true" x5-video-orientation="portraint" class="video"
                           controls="controls" autoplay></video>
                </div>
            </div>
        </div>

        <div v-if="newsContent.newsKind=='n'">
            <div class="newsInfo">
                <div class="newsTitle">{{newsContent.newsTitle}}</div>
                <div class="descContent">
                    <div class="source">{{newsContent.datePublish}}</div>
                    <div class="source">来源：{{newsContent.source||"暂无"}}</div>
                </div>
            </div>
            <div class="formatContent" v-html="newsContent.content"></div>
        </div>

        <div v-if="newsContent.newsKind==11">
            <div class="newsInfo">
                <div class="newsTitle">{{newsContent.newsTitle}}</div>
                <div class="descContent">
                    <div class="source">{{newsContent.source}}
                        <div class="publishTime">{{newsContent.datePublish}}</div>
                    </div>
                </div>
            </div>
            <div class="formatContent" v-html="newsContent.content"></div>
        </div>

    </div>
</template>

<script>
    import CONFIG from "@/utils/config";
    import COVERAPP from "@/utils/COVERAPP";
    import COVER from "@/utils/COVER";
    import QCard from "@/components/QCard";
    import {mapState, mapActions, mapMutations} from "vuex";
    import PageWrapper from "@/components/PageWrapper";
    export default {
        name: "NewsInfo",
        components: {QCard, PageWrapper},
        data() {
            return {
                iframeState: true,
                clientHeight: document.body.clientHeight,
                isPlay: false,
                isPauseClear: false,
                timeout: null,
                videoHeight: 290
            };
        },
        computed: {
            ...mapState(["linkSrc", "newsContent", "isToastShow"])
        },
        mounted() {
            if(this.isToastShow && this.newsContent.newsKind=='v'){
                this.judgePlay(true)
            }
        },
        watch: {
            homeChat(val) {
            },
            isToastShow(val) {
                this.judgePlay(val)
            },
            isPlay(val) {
                let that = this;
                if (val) {
                    this.timeout = setTimeout(function () {
                            that.isPauseClear = true;
                            if (!val) {
                                clearTimeout(that.timeout);
                            }
                        }
                        , 3000);
                } else {
                    that.isPauseClear = false;
                    clearTimeout(this.timeout);
                }
                this.setPlayAudio(val)
            }

        },
        destroyed() {
            clearTimeout(this.timeout);
        },
        methods: {
            ...mapMutations(["setPlayAudio"]),
            judgePlay(val) {
                let myVideo = document.getElementById("video");
                if (val) {
                    let that = this;
                    if (myVideo) {
                        myVideo.style.display = "block";
                        myVideo.addEventListener("loadedmetadata", function () {
                            that.videoHeight = myVideo.offsetHeight;
                            console.info("videoHeight", that.videoHeight);
                        }, false);
                        // myVideo.addEventListener("ended", function () {
                        //     that.isPlay = false;
                        // }, false);
                        // myVideo.addEventListener("pause", function () { //暂停开始执行的函数
                        //     that.isPlay = false;
                        // });
                        myVideo.addEventListener("playing", function () { //播放中
                            that.isPlay = true;
                        });
                    }
                } else {
                    if (myVideo) {
                        myVideo.pause();
                        myVideo.style.display = "none";
                    }
                    this.isPlay = false
                }
            },
            onPlay() {
                let myVideo = document.getElementById("video");
                const {isPlay} = this;
                if (isPlay) {
                    myVideo.pause();
                    this.isPlay = false;
                } else {
                    myVideo.play();
                    this.isPlay = true;
                }
            },
            onVideo() {
                this.isPauseClear = false;
            },
            onBack() {
                this.$router.back(-1);

            }
        }
    };
</script>

<style lang="less" scoped>
    .detail-back-btn {
        display: none !important;
    }

    .BlankWrapper {
        overflow: auto;
        /*padding:.9rem 0.35rem;*/
    }

    .pauseClear {
        display: none !important;
    }

    .playPause {
        font-size: 0;
        overflow: hidden;
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        z-index: 3;

        .playImg {
            width: 1.5rem;
            height: 1.5rem;
        }
    }

    .videoWrapper {
        background: #000;
        position: relative;
        font-size: 0;
        overflow: hidden;

        .videoPlay {
            width: 100%;
            position: absolute;
            height: 100%;
            /*background-color: #000;*/

            .video {
                min-height: 100%;
                position: absolute;
                left: 0;
                top: 50%;
                -webkit-transform: translateY(-50%);
                transform: translateY(-50%);
            }
        }


    }

    .newsInfo {
        margin-bottom: .2rem;
    }

    .newsTitle {
        font-size: .44rem;
        font-weight: 700;
        color: #171E32;
        padding: 0 0 .1rem;
    }

    .descContent {
        display: flex;
        justify-content: space-between;
        align-items: center;

        font-size: .44rem;



    }
    .publishTime {
        margin-left: .1rem;
        display: inline-block;
    }
    .source {
        font-size: .36rem;
        color: #a3a3a3;
    }


</style>
